import { z } from 'zod';
const sortColumnOptions = ['NAME', 'CATEGORY', 'DISPLAY_ORDER', 'CREATED_AT'] as const;
export const searchSchema = z.object({
  freeText: z.string().default(''),
  showDisabled: z.boolean().default(false),
  sortColumn: z.enum(sortColumnOptions).default('DISPLAY_ORDER'),
  sortOrder: z.enum(['ASC', 'DESC']).default('ASC')
});